import { useState, useRef, useCallback, useMemo, } from 'react';
import { setModalPos, getModalPos } from 'libs/client-env';
import { defaultScreenFraction, getDialogPosition, } from 'libs/dialog-position';
import { screenBreakpoints } from 'App/app-context';
const MODAL_POS_PREFIX = 'modalPos_';
const SMALL_SCREEN_OFFSET = 10;
const useModalPosition = (storageKey, dialogSize, defaultFractionalPos) => {
    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });
    const modalRef = useRef(null);
    const storageKeyWithPrefix = useMemo(() => `${MODAL_POS_PREFIX}${storageKey}`, [storageKey]);
    const getPosition = useCallback(() => {
        var _a;
        const defaultPosition = defaultFractionalPos !== null && defaultFractionalPos !== void 0 ? defaultFractionalPos : defaultScreenFraction;
        const userFractionalPos = getModalPos(storageKeyWithPrefix, defaultPosition);
        const targetRect = (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        let position;
        if (targetRect !== undefined) {
            position = getDialogPosition({
                width: targetRect.width,
                height: targetRect.height,
            }, defaultPosition, userFractionalPos);
        }
        else {
            position = getDialogPosition(dialogSize, defaultPosition, userFractionalPos);
        }
        if (window.innerWidth < screenBreakpoints.sm) {
            position.y = SMALL_SCREEN_OFFSET;
        }
        return position;
    }, [storageKeyWithPrefix, defaultFractionalPos, dialogSize]);
    const defaultPosition = useMemo(getPosition, []);
    const savePosition = useCallback(() => {
        if (!modalRef.current) {
            return;
        }
        const rect = modalRef.current.getBoundingClientRect();
        setModalPos(storageKeyWithPrefix, {
            widthFraction: rect.x / window.innerWidth,
            heightFraction: rect.y / window.innerHeight,
        });
    }, [storageKeyWithPrefix]);
    const onStart = useCallback((_event, uiData) => {
        var _a;
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    }, []);
    const onStop = useCallback(() => {
        savePosition();
    }, []);
    return {
        bounds,
        modalRef,
        defaultPosition,
        onStart,
        onStop,
    };
};
export default useModalPosition;
